<div class="preset-options">
    <div class="popover-container">
        <div class="minor-options">
            <div class="title-container">
                <div class="title">Underline Thickness</div>
            </div>
            <div class="options-container">
                <div class="options">
                    <div class="selections">
                        <div class="custom-slider">
                            <ngx-slider
                                [(value)]="thickValue"
                                [options]="thickOptions"
                                (userChangeStart)="onThicknessUserChangeStart($event)"
                                (userChange)="onThicknessUserChange($event)"
                                (userChangeEnd)="onThicknessUserChangeEnd($event)">
                            </ngx-slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="radius-options">
        <div class="title-container">
            <div class="title">Underline Spacing</div>
        </div>
        <div class="options-container">
            <div class="options">
                <div class="custom-slider">
                    <ngx-slider
                        [(value)]="distanceValue"
                        [options]="distanceOptions"
                        (userChangeStart)="onDistanceUserChangeStart($event)"
                        (userChange)="onDistanceUserChange($event)"
                        (userChangeEnd)="onDistanceUserChangeEnd($event)">
                    </ngx-slider>
                </div>   
            </div>
        </div>
    </div>
</div>
